import { Modal } from "../../modal";
import { DataGrid } from "@mui/x-data-grid";


export const OccurrenceModal = ({ open, handleOnClose, vehicleDetails }) => {
    const occurrences = [
        { id:3, NameOccurrence: 'Paradas sem descarga, cadastrada', AmountOccurrence: vehicleDetails.numberOfEvents_Withoutcharge},
        { id:4, NameOccurrence: 'Paradas com descarga, cadastrada', AmountOccurrence: vehicleDetails.numberOfEvents_Charge},
        { id:1, NameOccurrence: 'Paradas sem descarga, não cadastrada', AmountOccurrence: vehicleDetails.numberOfEvents_NotWithoutcharge},
        { id:2, NameOccurrence: 'Paradas com descarga, não cadastrada', AmountOccurrence: vehicleDetails.numberOfEvents_NotCharge},
        
    ];

    const columns = [
        {
            field: 'NameOccurrence',
            headerName: 'Eventos',
            width: 400,
            editable: false,
            headerAlign: 'center',
            
        },
        {
            field: 'AmountOccurrence',
            headerName: 'Quantidades',
            width: 250,
            editable: false,
            align: 'center',
            headerAlign: 'center',
        },

    ];

    return (
        <Modal
            showBackArrow
            open={open}
            onClose={handleOnClose}
            title={"Ocorrências"}
        >
            
            <div style={{ paddingTop: '20px', height: 450, width: '100%' }}>
                <DataGrid
                    rows={occurrences}
                    columns={columns}
                    pageSize={5}
                    hideFooter={true}
                    rowsPerPageOptions={[5]}
                />
            </div>
        </Modal >
    );
}